module.exports = {
          srcSet: __webpack_public_path__ + "images/1976-d9099e86460cff8287e7234747ebacb1-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1976-278015261ff3ddd5552357c071973f0d-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1976-d9099e86460cff8287e7234747ebacb1-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1976-278015261ff3ddd5552357c071973f0d-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1976-d9099e86460cff8287e7234747ebacb1-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1976-d9099e86460cff8287e7234747ebacb1-320.jpg"},
          
          width: 320,
          height: 251
        }